import {Component, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {AmenitiesService} from '../../../services/amenities.service';
import {AuthenticationService} from '../../../services/authentication.service';
import { environment } from 'environments/environment';
import { Http, RequestOptions, Headers } from '@angular/http';
import { AuthTokenService } from '../../../services/auth-token.service';

declare const toastr;

@Component({
    selector: 'amenities-quotes-modal',
    templateUrl: './amenities-quotes-modal.component.html',
    styleUrls: ['./amenities-quotes-modal.component.scss']
})
export class AmenitiesQuotesModalComponent implements OnInit {
    showModal = false;
    disabledSubmit = false;
    data = null;
    step = 'offer';
    selectedAnswer = null;
    answers = [
        {id: '1', answer: 'I already booked my mover', checked: false},
        {id: '2', answer: 'I am going to do the move myself', checked: false},
        {id: '3', answer: 'I know a great mover and I don\'t need your services', checked: false},
        {id: '4', answer: 'I don\'t trust you', checked: false},
        {id: '5', answer: 'Other (please specify)', checked: false}
    ];
    otherReason: '';

    constructor(
        public api: ApiClientService,
        public amenitiesService: AmenitiesService,
        public authService: AuthenticationService,
        private http: Http,
        private authTokenService: AuthTokenService
    ) {

    }

    ngOnInit() {
        this.data = this.amenitiesService.quoteModalObject;
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {

    }

    getQuote() {
        const url = `${environment.domainQuotes}?type=${this.data.uses}&phone=${this.data.phone}&date=${this.data.startDate}&name=${this.data.residentFullName}&address=${this.data.buildingName}&corp=${this.data.corporationId}`;
        window.open(encodeURI(url));
    }

    goToCancelQuestionary() {
        this.step = 'cancelled';
    }

    goBackToOffer() {
        this.step = 'offer';
        this.otherReason = '';
        this.selectedAnswer = null;
    }

    sendRejectReason() {
        if(!this.answers.some(a => a.checked)) {
            toastr.warning('Please, check at least one option');
            return;
        }
        if(this.answers[4].checked && !this.otherReason) {
            toastr.warning('Please, fill the other reason field.');
            return;
        }
        this.disabledSubmit = true;

        const data = {
            data: {
                name: this.authService.user.fullName,
                message: `${this.getSelectedAnswersString()}`,
            },
            subject: `${this.amenitiesService.quoteModalObject.amenityName} moving quote reject reason`,
            formName: 'mcc:get_quote'
        };

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post('https://maxtvmedia.com/condoclub/notice.php', data, options).subscribe(
            () => this.hideModal(),
            error => {
                this.api.errorHandler(error, `Failed to send reject reason.`);
                this.disabledSubmit = false;
            }
        );
    }

    getSelectedAnswersString() {
        let answersString = '';

        this.answers.forEach(a => {
            if(a.checked)
                answersString += a.id != '5' ? (a.answer + '. ') : this.otherReason;
        });

        return answersString;
    }

    hideModal() {
        this.amenitiesService.showQuoteModal = false;
        this.amenitiesService.quoteModalType = '';
        this.amenitiesService.quoteModalObject = null;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenity-quotes-modal/amenities-quotes-modal.component.ts